import { createAsyncThunkFromFetch } from 'src/store/utils';
import { FetchCompanyParams, FetchCompanyResponse } from './company.types';
import { getCompany } from './company.api';

export const fetchCompanyAction = createAsyncThunkFromFetch<
  FetchCompanyResponse,
  FetchCompanyParams
>('companies/company', getCompany);
